import { render, staticRenderFns } from "./Richmenu.vue?vue&type=template&id=17c16751&scoped=true&"
import script from "./Richmenu.vue?vue&type=script&lang=js&"
export * from "./Richmenu.vue?vue&type=script&lang=js&"
import style0 from "./Richmenu.vue?vue&type=style&index=0&id=17c16751&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c16751",
  null
  
)

export default component.exports